"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoldingWithIsRecipeEnabledMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class HoldingWithIsRecipeEnabledMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isLoading = lodash_1.default.get(result, "loading");
        const isRecipeDetailsEnabled = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.isRecipeDetailsEnabled", false);
        return {
            hasError,
            isLoading,
            isRecipeDetailsEnabled,
        };
    }
}
exports.HoldingWithIsRecipeEnabledMapper = HoldingWithIsRecipeEnabledMapper;
